import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import moment from 'moment';
import {
  RenderField,
  RenderDatePicker,
  RenderCheckboxRadioField,
  RenderSwitchButton,
  RenderSubmitButton
} from '../../common/form';
import * as Validations from '../../common/form/commonValidations';

const WeddingDetails = ({ skipDate, handleSubmit, weddingDate, change, valid }) => { // eslint-disable-line
  return (
    <div className="wedding-details__container">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xs-12"><label htmlFor="owner-first-name__field">You are:</label></div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-3">
            <Field
              id="owner-first-name__field"
              placeholder="First Name"
              name="owner_first_name"
              type="text"
              component={RenderField}
              validate={Validations.REQUIRED}
              required
            />
          </div>
          <div className="col-xs-12 col-sm-3">
            <Field
              id="owner-last-name__field"
              placeholder="Last Name"
              name="owner_last_name"
              type="text"
              component={RenderField}
              validate={Validations.REQUIRED}
              required
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Field
              id="owner-role__field-bride"
              name="owner_wedding_role"
              component={RenderSwitchButton}
              type="radio"
              value="BRIDE"
              label="Bride"
              validate={Validations.REQUIRED}
              ariaLabel="Is Bride"
            />
            <Field
              id="owner-role__field-groom"
              name="owner_wedding_role"
              component={RenderSwitchButton}
              type="radio"
              value="GROOM"
              label="Groom"
              validate={Validations.REQUIRED}
              ariaLabel="Is Groom"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12"><label htmlFor="partner-first-name__field">Your spouse-to-be is:</label></div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-3">
            <Field
              id="partner-first-name__field"
              placeholder="First Name"
              name="partner_first_name"
              type="text"
              component={RenderField}
              validate={Validations.REQUIRED}
              required
            />
          </div>
          <div className="col-xs-12 col-sm-3">
            <Field
              id="partner-last-name__field"
              placeholder="Last Name"
              name="partner_last_name"
              type="text"
              component={RenderField}
              validate={Validations.REQUIRED}
              required
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Field
              id="partner-role__field-bride"
              name="partner_wedding_role"
              component={RenderSwitchButton}
              type="radio"
              value="BRIDE"
              label="Bride"
              validate={Validations.REQUIRED}
              ariaLabel="Is Bride"
            />
            <Field
              id="partner-role__field-groom"
              name="partner_wedding_role"
              component={RenderSwitchButton}
              type="radio"
              value="GROOM"
              label="Groom"
              validate={Validations.REQUIRED}
              ariaLabel="Is Groom"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-3 wedding-details__wedding-date">
            <Field
              id="wedding-date__picker"
              name="wedding_date"
              component={RenderDatePicker}
              disabled={skipDate}
              label="Your big day is:"
              validate={skipDate ? undefined : [Validations.REQUIRED, Validations.DATE, Validations.CHECK_CURRENT_WEDDING_DATE, Validations.DATE_WITHIN_VALID_RANGE]}
            />
          </div>
          <div className="col-xs-12 col-sm-6 wedding-details__skip-date">
            <Field
              name="skipDate"
              id="wedding-skip-date__radio"
              styleOverride
              component={RenderCheckboxRadioField}
              type="checkbox"
              label="We haven't decided yet."
              onChange={() => change('wedding_date', null)}
            />
          </div>
        </div>
        <div className="col-xs-12">
          <RenderSubmitButton valid={skipDate || valid} className="btn btn-primary btn-wide" value="Save Changes" />
          <div className="wedding-details__help">Questions? <a className="bold" href="https://help.zola.com/hc/en-us" target="_blank" rel="noopener noreferrer">We&apos;re here to help.</a></div>
        </div>
      </form>
    </div>
  );
};

WeddingDetails.propTypes = {
  handleSubmit: PropTypes.func,
  skipDate: PropTypes.bool,
  weddingDate: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  change: PropTypes.func,
};

const formatDate = (date) => {
  const formattedDate = date ? moment.utc(date).format('MM/DD/YYYY') : undefined;
  return formattedDate;
};

const mapStateToProps = (state) => {
  const selector = formValueSelector('WeddingDetails');

  return {
    initialValues: {
      ...state.wedding.wedding,
      wedding_date: formatDate(state.wedding.wedding.wedding_date),
      skipDate: !state.wedding.wedding.wedding_date,
      currentlySelectedDate: state.wedding.wedding.wedding_date,
      registryIsPublic: state.registry.public,
    },
    skipDate: selector(state, 'skipDate') === true,
    weddingDate: selector(state, 'wedding_date'),
  };
};

const WeddingDetailsForm = reduxForm({
  form: 'WeddingDetails',
  enableReinitialize: true
})(WeddingDetails);

export default connect(mapStateToProps)(WeddingDetailsForm);



// WEBPACK FOOTER //
// ./src/components/settings/wedding/WeddingDetails.jsx